'use client'

import { Box } from '@chakra-ui/react'
import React from 'react'
import SliderDesktop from './slider.desktop'
import SliderMobile from './slider.moblie'
import '@/app/[locale]/_styles/embla.css'

const Slider = ({ list }: { list: string[] }) => {
  return (
    <>
      <Box display={{ base: 'none', lg: 'block' }}>
        <SliderDesktop list={list} />
      </Box>
      <Box display={{ base: 'block', lg: 'none' }}>
        <SliderMobile list={list} />
      </Box>
    </>
  )
}

export default Slider
